import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect, useContext } from 'react';

import { TopBanner } from '@bingads-webui-react/notification-center';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LayoutContext, Mode } from '@bingads-webui-react/app-layout-container';

import { useAdBlockerDetection } from './use-ad-blocker';

export function AdBlockerBanner({ query, logMessage }) {
  const i18n = useContext(I18nContext);
  const adBlockerMessage = useAdBlockerDetection({
    i18n,
    query,
    logMessage,
  });
  const { config, change: changeLayout } = useContext(LayoutContext);

  useEffect(() => {
    const mode = _.isEmpty(adBlockerMessage) ? Mode.Hidden : Mode.Expanded;
    if (mode !== (config && config.topBanner && config.topBanner.mode)) {
      changeLayout({ topBanner: { mode } });
    }
  }, [adBlockerMessage, changeLayout, config]);

  return (
    <div className="blocker-detection-banner">
      {
        !_.isEmpty(adBlockerMessage) &&
        <TopBanner notifications={adBlockerMessage} />
      }
    </div>
  );
}

AdBlockerBanner.propTypes = {
  query: PropTypes.string,
  logMessage: PropTypes.func,
};

AdBlockerBanner.defaultProps = {
  query: undefined,
  logMessage: undefined,
};
